export const tripLodgingEn = {
  pageTitle: 'Trip Lodging',
  lodgingManagement: 'Lodging Management',
  stayCount: (stays: number, cities: number) => {
    if (stays === 1 && cities === 1) return '1 stay across 1 city';
    return `${stays} stays across ${cities} cities`;
  },
  emptyTitle: 'No hotels added yet',
  emptyDescription:
    'Add lodging to your trip cities to manage your accommodations',
  addHotel: 'Add Hotel',
  editHotel: 'Edit Hotel',
  deleteStay: 'Delete Hotel Stay',
  deleteConfirm: 'Delete this hotel stay?',
  done: 'Done',
  cancel: 'Cancel',
  save: 'Save',
  back: 'Back',
  map: 'Map',
  nights: (n: number) => (n === 1 ? '1 night' : `${n} nights`),
  conf: 'Conf:',
  notes: 'Notes',
  selectCity: 'Select city',
  showAllPorts: 'Show all ports',
  prePostHint:
    'Showing pre- and post-cruise lodging cities. Turn on “Show all ports” to add lodging at a call port.',
  lodgingAlready: 'Lodging',
  missingTrip: 'Trip not found',
  missingCity: 'Choose a city for this hotel stay',
  hotelInformation: 'Hotel Information',
  hotelName: 'Hotel Name',
  hotelNameRequired: 'Hotel name is required',
  address: 'Address',
  phone: 'Phone Number',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  checkOutAfterCheckIn: 'Check-out must be after check-in',
  confirmation: 'Confirmation',
  confirmationNumber: 'Confirmation Number',
  confirmations: 'Confirmations',
  addConfirmation: 'Add',
  editConfirmation: 'Edit',
  noConfirmations: 'No confirmations',
  additionalNotes: 'Additional Notes',
  notesPlaceholder: 'Room type, guest name, rate type, etc.',
  enterManually: 'Enter manually',
  searchInstead: 'Search instead',
  searchHotels: 'Search hotels',
  hotelNameSearchPlaceholder: 'Search hotels by name…',
  hotelNameSearchLabel: 'Search hotels by name',
  hotelNameSearchClear: 'Clear hotel search',
  hotelNameSearchAction: 'Search',
  hotelNameSearchOffline: 'Connect to the internet to search hotels by name.',
  hotelNameSearchEmpty: 'No hotels match that name near this area.',
  hotelNameSearchNoLocal:
    'No matching hotels in this list. Press Search to look up more.',
  stayArea: 'Recommended stay area',
  stayAreaRationale: 'Why',
  cityCenter: 'City center',
  useRecommended: 'Recommended area',
  searching: 'Searching hotels…',
  searchEmpty: 'No hotel offers found for these dates.',
  searchError: 'Hotel search failed. Try again.',
  retry: 'Retry',
  showMore: 'Show more',
  addToTrip: 'Add to trip',
  bookNow: 'Book now',
  filters: 'Filters',
  applyFilters: 'Apply',
  resetFilters: 'Reset',
  sort: 'Sort',
  sortDistance: 'Distance',
  sortPrice: 'Price',
  sortRating: 'Rating',
  sortStars: 'Stars',
  saveOfferTitle: 'Save hotel',
  bookTitle: 'Book hotel',
  guestFirstName: 'First name',
  guestLastName: 'Last name',
  guestEmail: 'Email',
  guestPhone: 'Phone (E.164)',
  guestDob: 'Date of birth',
  guestGender: 'Gender',
  genderMale: 'Male',
  genderFemale: 'Female',
  genderOther: 'Other',
  guestCountry: 'Country',
  businessTrip: 'Business trip',
  submitBooking: 'Continue to payment',
  bookingPending: 'Waiting for payment confirmation…',
  bookingConfirmed: 'Booking confirmed',
  bookingFailed: 'Booking failed. Search again for a fresh offer.',
  openPayment: 'Open payment',
  retryPayment: 'Retry payment',
  readOnly: 'You can view lodging on this trip, but editing is read-only.',
  unknownCity: 'Unknown City',
} as const;
